import { useAuiState } from '@assistant-ui/react';

import { useMessageLocaleMap } from '@/components/providers/read-only-runtime-provider';
import { getTextDirection } from '@/lib/utils/locale-shared';

interface MessageLocaleResult {
  messageLocale: string | undefined;
  messageDir: 'ltr' | 'rtl' | undefined;
}

export function useMessageLocale(): MessageLocaleResult {
  const messageId = useAuiState(({ message }) => message.id);
  const messageLocaleMap = useMessageLocaleMap();
  const messageLocale = messageLocaleMap[messageId];
  const messageDir = messageLocale ? getTextDirection(messageLocale) : undefined;
  return { messageLocale, messageDir };
}
